export default {"src":"/_next/static/media/logo-black.fb26ad84.svg","height":26,"width":81,"blurWidth":0,"blurHeight":0};